import { useState, useCallback } from 'react';
import TodoForm from './components/TodoForm';
import TodoList from './components/TodoList';
import  './App.css';
function App() {
  const [taches, setTaches] = useState([]);

  const ajouterTache = useCallback((texte) => {
    const nouvelleTache = {
      id: crypto.randomUUID(), 
      texte,
      terminee: false
    };
    setTaches((prevTaches) => [...prevTaches, nouvelleTache]);
  }, []);

  const changerEtat = useCallback((id) => {
    setTaches((prevTaches) =>
      prevTaches.map((t) =>
        t.id === id ? { ...t, terminee: !t.terminee } : t
      )
    );
  }, []);

  const supprimerTache = useCallback((id) => {
    setTaches((prevTaches) => prevTaches.filter((t) => t.id !== id));
  }, []);

  return (
    <main>
      <h1>To-Do List Interactive</h1>
      <TodoForm ajouterTache={ajouterTache} />
      <TodoList
        taches={taches}
        changerEtat={changerEtat}
        supprimerTache={supprimerTache}
      />
    </main>
  );
}

export default App;